"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftCrossSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("react");
const enums_1 = require("@bemlo/enums");
const constants_1 = require("../../constants");
const shiftHoursDesign = {
    DAY: {
        ordinary: constants_1.Color.BLUE,
        onCall: constants_1.Color.MEDIUM_BLUE,
        onCallLight: constants_1.Color.LIGHTER_BLUE,
    },
    EVENING: {
        ordinary: constants_1.Color.RED,
        onCall: constants_1.Color.MEDIUM_RED,
        onCallLight: constants_1.Color.LIGHTER_RED,
    },
    LONG: {
        ordinary: constants_1.Color.PURPLE,
        onCall: constants_1.Color.MEDIUM_RED,
        onCallLight: constants_1.Color.LIGHTER_RED,
    },
    NIGHT: {
        ordinary: constants_1.Color.VIOLET,
        onCall: constants_1.Color.DEEP_PURPLE,
        onCallLight: constants_1.Color.LIGHT_PURPLE,
    },
};
const LabelWrapper = styled_1.default.div({
    position: 'relative',
    width: '100%',
});
const Container = styled_1.default.div(({ length, height, rounded, design, mt }) => ({
    position: 'relative', // Added this line
    display: 'grid',
    gridTemplateColumns: `repeat(${length}, 1fr)`,
    width: '100%',
    height,
    marginTop: mt,
    borderRadius: constants_1.theme.border.radius.normal,
    border: constants_1.theme.border.style.thin,
    borderColor: design.ordinary,
    overflow: 'hidden',
    ...(rounded && {
        div: {
            borderRadius: 10000,
            ':not(:last-child)': {
                marginRight: 2,
            },
        },
        border: 'none',
    }),
}));
const Segment = styled_1.default.div(({ length, design, background }) => ({
    gridColumn: `span ${length}`,
    background: background === 'filled'
        ? design.ordinary
        : background === 'light'
            ? design.onCallLight
            : `repeating-linear-gradient(
            -45deg,
            ${design.onCall} 0,
            ${design.onCall} 6px,
            ${design.onCallLight} 6px,
            ${design.onCallLight} 12px
          )`,
}));
const Badge = (props) => {
    const positionStyles = props.left
        ? {
            left: props.left,
            transform: 'translateX(-50%)',
        }
        : {
            [props.x || 'left']: '0',
        };
    return ((0, jsx_runtime_1.jsx)("div", { className: "label", style: {
            position: 'absolute',
            background: props.background,
            color: constants_1.Color.WHITE,
            padding: '0.1rem 0.3rem',
            borderRadius: '0.4rem',
            fontSize: 12,
            zIndex: 1,
            [props.y === 'over' ? 'top' : 'bottom']: '-1.2rem', // Adjusted for better spacing
            ...(props.x === 'left' && { borderBottomLeftRadius: '0' }),
            ...(props.x === 'right' && { borderBottomRightRadius: '0' }),
            ...positionStyles,
        }, children: props.time }));
};
const ShiftCrossSection = ({ mt, shiftHours, startDateTime, endDateTime, onCallTime, size, labeled, }) => {
    const design = shiftHoursDesign[shiftHours || enums_1.ShiftHours.DAY];
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const height = size === 'sm'
        ? constants_1.theme.spacing[1]
        : size === 'md'
            ? constants_1.theme.spacing[2]
            : constants_1.theme.spacing['3.5'];
    const length = endDateTime.diff(startDateTime, 'minute');
    if (!onCallTime) {
        return ((0, jsx_runtime_1.jsx)(Container, { design: design, length: length, height: height, rounded: size === 'sm', mt: mt, children: (0, jsx_runtime_1.jsx)(Segment, { design: design, length: length, background: "filled" }) }));
    }
    const onCallLength = onCallTime.endDateTime.diff(onCallTime.startDateTime, 'minute');
    const onCallStart = onCallTime.startDateTime.diff(startDateTime, 'minute');
    const onCallEnd = onCallTime.endDateTime.diff(startDateTime, 'minute');
    const firstSegmentLength = onCallStart;
    const secondSegmentLength = onCallLength;
    const thirdSegmentLength = length - onCallEnd;
    const firstTransitionPosition = (onCallStart / length) * 100;
    const secondTransitionPosition = (onCallEnd / length) * 100;
    return ((0, jsx_runtime_1.jsxs)(LabelWrapper, { onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), children: [(0, jsx_runtime_1.jsxs)(Container, { design: design, length: length, height: height, rounded: size === 'sm', mt: mt, children: [!!firstSegmentLength && ((0, jsx_runtime_1.jsx)(Segment, { length: firstSegmentLength, design: design, background: "filled" })), (0, jsx_runtime_1.jsx)(Segment, { length: secondSegmentLength, design: design, background: size === 'sm' ? 'light' : 'striped' }), !!thirdSegmentLength && ((0, jsx_runtime_1.jsx)(Segment, { length: thirdSegmentLength, design: design, background: "filled" }))] }), (labeled === true || (isHovered && labeled === 'hover')) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Badge, { time: startDateTime.format('HH:mm'), x: "left", y: "over", background: constants_1.Color.BLUE }), !!firstSegmentLength && ((0, jsx_runtime_1.jsx)(Badge, { time: onCallTime.startDateTime.format('HH:mm'), y: "under", left: `${firstTransitionPosition}%`, background: constants_1.Color.MEDIUM_BLUE })), !!thirdSegmentLength && ((0, jsx_runtime_1.jsx)(Badge, { time: onCallTime.endDateTime.format('HH:mm'), y: "under", left: `${secondTransitionPosition}%`, background: constants_1.Color.MEDIUM_BLUE })), (0, jsx_runtime_1.jsx)(Badge, { time: endDateTime.format('HH:mm'), x: "right", y: "over", background: constants_1.Color.BLUE })] }))] }));
};
exports.ShiftCrossSection = ShiftCrossSection;
